export default function () {
  const widgetName = 'footerBG';
  const widgetOpts = footerBGOpts;

  function setBackgroundImage(data) {
    const item = data.items[0].ImageWithPath;
    const bgImage = `url('${item}') center / cover no-repeat #000`;
    $('footer').css('background', bgImage);
    $(`#${widgetName}`).remove();
  }
  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      setBackgroundImage(data);
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
